import _objectSpread from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _regeneratorRuntime from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { MarkerManager } from './MarkerManager/MarkerManager';
import { TextManager } from './TextManager/TextManager';
import { Foglet, communication } from 'foglet-core';
import { EventEmitter } from 'events';

var debug = require('debug')('CRATE:Communication');

export var Communication =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Communication, _EventEmitter);

  function Communication(opts) {
    var _this;

    _classCallCheck(this, Communication);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Communication).call(this));
    _this._options = opts;
    _this._document = _this._options.document;
    return _this;
  }

  _createClass(Communication, [{
    key: "initModules",
    value: function () {
      var _initModules = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var opts,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                this.causality = this._data_comm.broadcast._causality;
                this.markerManager = new MarkerManager(this._options);
                this.textManager = new TextManager(this._options);
                _context.next = 6;
                return this.waitAntientropy();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function initModules() {
        return _initModules.apply(this, arguments);
      };
    }()
  }, {
    key: "initConnection",
    value: function () {
      var _initConnection = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // get ICEs
                this._document.setMessageState('Connecting: getting ICEs ...');

                _context2.next = 3;
                return this.setWebRTCOptions(this._options);

              case 3:
                this._document.setMessageState('Connecting: establishing connection ...'); //connection between foglets


                if (this._options.foglet) {
                  this._foglet = this._options.foglet;
                } else {
                  //Connection using the signaling server
                  this._foglet = this.getNewFoglet(this._options);
                  this._options._foglet = this._foglet;

                  this._foglet.share();
                }

                _context2.prev = 5;
                _context2.next = 8;
                return this.fogletConnection();

              case 8:
                this._document.setMessageState('Connecting: connection established...');

                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](5);

                this._document.setMessageState('Connecting: Could not establish connection!');

              case 14:
                this.setCommunicationChannels();

                this._foglet.emit('connected');

                debug('application connected!');

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      return function initConnection() {
        return _initConnection.apply(this, arguments);
      };
    }()
  }, {
    key: "fogletConnection",
    value: function () {
      var _fogletConnection = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var maxRetry,
            connect,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                maxRetry = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : 3;

                connect =
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee3(retry) {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return _this2._foglet.connection(_this2._options.foglet);

                          case 3:
                            _context3.next = 14;
                            break;

                          case 5:
                            _context3.prev = 5;
                            _context3.t0 = _context3["catch"](0);

                            if (!(retry > 0)) {
                              _context3.next = 13;
                              break;
                            }

                            console.error(_context3.t0);
                            _context3.next = 11;
                            return connect(retry - 1);

                          case 11:
                            _context3.next = 14;
                            break;

                          case 13:
                            throw new Error('Could not establish connection!', _context3.t0);

                          case 14:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this, [[0, 5]]);
                  }));

                  return function connect(_x) {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context4.next = 4;
                return connect(maxRetry);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function fogletConnection() {
        return _fogletConnection.apply(this, arguments);
      };
    }()
  }, {
    key: "waitAntientropy",
    value: function () {
      var _waitAntientropy = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new Promise(function (resolve, reject) {
                  var neighborhoodSize = _this3._foglet.getNeighbours(Infinity).length;

                  if (neighborhoodSize === 0) {
                    resolve();
                  } else {
                    _this3._document.setMessageState('Loading Content...');

                    _this3.on('startReceivingStream', function () {});

                    _this3.on('endReceivingStream', function () {
                      resolve();
                    });
                  }
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      return function waitAntientropy() {
        return _waitAntientropy.apply(this, arguments);
      };
    }() //TODO: Make this global to use the same server for all the documents

    /**
     * set WebRTCOptions
     * @description  set the default options of ice Servers and replace them by the ice server if it is possible. if it run in node js use wrtc.
     */

  }, {
    key: "setWebRTCOptions",
    value: function () {
      var _setWebRTCOptions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(options) {
        var defaultICE, twilioICEs, iceServers;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (options.foglet) {
                  _context6.next = 9;
                  break;
                }

                defaultICE = [{
                  url: options.stun,
                  urls: options.stun
                }];
                _context6.next = 4;
                return this.getICEs(options);

              case 4:
                twilioICEs = _context6.sent;
                iceServers = Object.assign(defaultICE, twilioICEs);
                options.webRTCOptions = {
                  trickle: true,
                  config: {
                    iceServers: iceServers
                  }
                };

                if (options.wrtc) {
                  options.webRTCOptions.wrtc = options.wrtc;
                }

                options.fogletOptions.rps.options.webrtc = options.webRTCOptions;

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      return function setWebRTCOptions(_x2) {
        return _setWebRTCOptions.apply(this, arguments);
      };
    }()
    /**
     * Get ICES
     * @description  Twillo is used to get list of ICEs servers, the script that generates the list of the servers is in the configuration "https://carteserver.herokuapp.com/ice"
     * @return arrays of ICE objects {url, urls, username, credential}
     */

  }, {
    key: "getICEs",
    value: function () {
      var _getICEs = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(options) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new Promise(function (resolve, reject) {
                  var url = options.ICEsURL || 'https://carteserver.herokuapp.com/ice';

                  if (url) {
                    fetch(url).then(function (resp) {
                      return resp.json();
                    }) // Transform the data into json
                    .then(function (addresses) {
                      var ICEs = addresses.ice.map(function (ice) {
                        ice.urls = ice.url;
                        return ice;
                      });
                      resolve(ICEs);
                    });
                  } else {
                    reject('no ICEsURL in url');
                  }
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      return function getICEs(_x3) {
        return _getICEs.apply(this, arguments);
      };
    }()
  }, {
    key: "getNewFoglet",
    value: function getNewFoglet(options) {
      return new Foglet(options.fogletOptions);
    }
  }, {
    key: "setCommunicationChannels",
    value: function setCommunicationChannels() {
      this._data_comm = new communication(this._foglet.overlay().network, '_data_comm');
      this.routeMsgToEvents(this._data_comm);
      this._behaviors_comm = new communication(this._foglet.overlay().network, '_behaviors_comm');
      this.routeMsgToEvents(this._behaviors_comm);
    }
  }, {
    key: "routeMsgToEvents",
    value: function routeMsgToEvents(communicatioChannel) {
      var _this4 = this;

      communicatioChannel.onBroadcast(function (id, message) {
        _this4._document.emit(message.event, message);
      });
      communicatioChannel.onUnicast(function (id, message) {
        _this4._document.emit(message.event, message);
      });
      communicatioChannel.onStreamBroadcast(function (id, message) {
        _this4.receiveStream(id, message);
      });
      communicatioChannel.onStreamUnicast(function (id, message) {
        _this4.receiveStream(id, message);
      });
    }
  }, {
    key: "receiveStream",
    value: function receiveStream(id, stream) {
      var _this5 = this;

      debug('document', 'receiving a stream from ', id);
      this.emit('startReceivingStream');
      var content = '';
      var first = true;
      var numberOfChunks = 1;
      var receivedChunks = 0;
      var percentage = 0;
      stream.on('data', function (data) {
        if (first) {
          numberOfChunks = data.numberOfChunks;
          debug('numberOfChunks === ', numberOfChunks);
          first = false;
        } else {
          receivedChunks++;
          var percentageNow = Math.floor(receivedChunks * 100 / numberOfChunks);

          if (percentageNow > percentage) {
            percentage = percentageNow;
            debug('percentage === ', percentage);

            _this5._document.setMessageState('Loading Content ' + percentage + '%');
          }

          content += data;
        }
      });
      stream.on('end', function () {
        var packet = JSON.parse(content);
        content = '';
        debug('document', 'Message received', packet.pairs, 'from', id);

        _this5.receive(packet.event, packet, id);

        _this5.emit('endReceivingStream');
      });
    }
  }, {
    key: "receive",
    value: function receive(event, packet, originID) {
      debug('communication receive ', event, packet);

      this._document.emit(event, _objectSpread({}, packet, {
        originID: originID
      }));
    }
  }, {
    key: "close",
    value: function close() {
      var _this6 = this;

      if (this.markerManager) this.markerManager.close();
      if (this.textManager) this.textManager.close();

      this._foglet.unshare();

      this._foglet._networkManager._rps.network._rps.disconnect();

      setTimeout(function () {
        _this6._foglet = null;
      }, 2000);
    }
  }]);

  return Communication;
}(EventEmitter);